import { ResponseDTO } from "medere-ui-framework";

export const CbuErrorMessages = {
    BAD_LENGTH: "Debe tener 22 dígitos",
    BAD_BANKBRANCH: "La sucursal bancaria no es válida",
    BAD_ACCOUNT: "La cuenta bancaria no es válida"
};

function validateCBULength(cbu: string | undefined): boolean {
    return cbu?.length === 22;
}

function validateBankBranch(code: string): boolean {
    if (code.length !== 8) {
        return false;
    }
    const bank = code.substring(0, 3),
          branch = code.substring(3, 7),
          checksum2 = parseInt(code[7], 10),
          sum = parseInt(bank[0], 10) * 7 + parseInt(bank[1], 10) * 1 + parseInt(bank[2], 10) * 3 +
          parseInt(branch[0], 10) * 9 + parseInt(branch[1], 10) * 7 + parseInt(branch[2], 10) * 1 + parseInt(branch[3], 10) * 3,
          diff = 10 - (sum % 10);
    return diff % 10 === checksum2;
}

function validateAccount(num: string): boolean {
    if (num.length !== 14) {
        return false;
    }
    const checksum = parseInt(num[13], 10),
          sum = parseInt(num[0], 10) * 3 +
                parseInt(num[1], 10) * 9 + parseInt(num[2], 10) * 7 + parseInt(num[3], 10) * 1 + parseInt(num[4], 10) * 3 +
                parseInt(num[5], 10) * 9 + parseInt(num[6], 10) * 7 + parseInt(num[7], 10) * 1 + parseInt(num[8], 10) * 3 +
                parseInt(num[9], 10) * 9 + parseInt(num[10], 10) * 7 + parseInt(num[11], 10) * 1 + parseInt(num[12], 10) * 3,
          diff = 10 - (sum % 10);
    return diff % 10 === checksum;
}

export function validateCBU(cbu: string): ResponseDTO {
    const response: ResponseDTO = {
        success: false,
        errormessage: "",
        items: [],
        data: null
    };

    if (validateCBULength(cbu)) {
        if (validateBankBranch(cbu.substring(0, 8))) {
            if (validateAccount(cbu.substring(8, 22))) {
                response.success = true;
            } else {
                response.errormessage = CbuErrorMessages.BAD_ACCOUNT;
            }
        } else {
            response.errormessage = CbuErrorMessages.BAD_BANKBRANCH;
        }
    } else {
        response.errormessage = CbuErrorMessages.BAD_LENGTH;
    }

    return response;
}

export function useCBUValidatorService() {
  return {
    validateCBU,
    CbuErrorMessages,
  }
}
